import { TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import usePrevious from "libs/hooks/usePrevious";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

export default function JobSection({
  colSpan = 6,
  bagdeStart = 19,
  formik,
  prefixFieldName = "",
  disabled = false
}) {
  const classes = useStyles();
  const masterData = useSelector(selectMasterData);

  // console.log(masterData);
  const jobPositionConfig = get(masterData, "jobPositionConfig", []);

  const prevJobPosition = usePrevious(formik.values.JobPosition);
  const isJobPositionChange =
    prevJobPosition && prevJobPosition !== formik.values.JobPosition;
  const canEdit = useSelector(canEditForm);
  useEffect(() => {
    if (isJobPositionChange) {
      formik.setFieldValue("JobSubPosition", "");
    }
  }, [formik, isJobPositionChange]);

  const index = 0;
  const jobTable = get(
    formik.values,
    `document.JobPositionWorkPermit.${index}`,
    {}
  );

  const jobSubPositionConfig =
    jobPositionConfig.find((job) => job.jobID === jobTable.jobID)
      ?.jobSubPosition || [];

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div
              className={classes.flexRow}
              style={{ flex: 1, display: "flex" }}
            >
              <InputLabel>Job position</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job position</InputLabel>
                <Select
                  disabled={disabled || !canEdit}
                  label="Select Job position"
                  name={`document.JobPositionWorkPermit.${index}.jobID`}
                  defaultValue=""
                  // value={get(
                  //   formik.values,
                  //   `document.JobTable.${index}.jobID`,
                  //   ""
                  // )}
                  value={formik.values.document.JobPositionWorkPermit[0].jobID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobPositionConfig.map((jobPosition) => (
                    <MenuItem key={jobPosition.jobID} value={jobPosition.jobID}>
                      {jobPosition.jobName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job Sub position</InputLabel>

                <Select
                  disabled={disabled || !canEdit}
                  label="Select Job Sub position"
                  name={`document.JobPositionWorkPermit.${index}.jobsubID`}
                  value={
                    formik.values.document.JobPositionWorkPermit[0].jobsubID
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobSubPositionConfig.map((jobPosition) => (
                    <MenuItem
                      key={jobPosition.jobsubID}
                      value={jobPosition.jobsubID}
                    >
                      {jobPosition.jobsubName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Job Title (Type of work according to WP.46 form)
              </InputLabel>
              <TextField
                disabled={disabled || !canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionWorkPermit.${index}.jobTitle`}
                value={get(
                  formik.values,
                  `document.JobPositionWorkPermit.${index}.jobTitle`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `document.JobPositionWorkPermit.${index}.jobTitle`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionWorkPermit.${index}.jobTitle`,
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Job description (Nature of work according to Form WP.46)
              </InputLabel>
              <TextField
                disabled={disabled || !canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionWorkPermit.${index}.jobDesc`}
                value={get(
                  formik.values,
                  `document.JobPositionWorkPermit.${index}.jobDesc`,
                  ""
                )}
                error={isError(
                  `document.JobPositionWorkPermit.${index}.jobDesc`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionWorkPermit.${index}.jobDesc`,
                  formik
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                multiline
                rows={5}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
